import { useMemo } from 'react'
import type { ChatMapMarker } from 'tripPlanner/components/ChatMap/types'
import DrawerDetailMap from '../DrawerDetailMap'
import type { OfferDetailGeoLocation } from './types'
import type { MapCameraPosition } from 'tripPlanner/api/types'

interface Props {
  geoLocation: OfferDetailGeoLocation
  offerName: string
  offerId: string
  offerType: 'hotel' | 'experience'
  onEnlarge?: (camera: MapCameraPosition) => void
}

function OfferDetailMap({ geoLocation, offerName, offerId, offerType, onEnlarge }: Props) {
  const placeId = offerId

  const markers = useMemo<Array<ChatMapMarker>>(() => [{
    markerKey: placeId,
    lat: geoLocation.lat,
    lng: geoLocation.lng,
    label: offerName,
  }], [placeId, geoLocation.lat, geoLocation.lng, offerName])

  return (
    <DrawerDetailMap
      markers={markers}
      initialCenterPlaceId={placeId}
      offerId={offerId}
      offerType={offerType}
      onEnlarge={onEnlarge}
    />
  )
}

export default OfferDetailMap
